import React from 'react';
import './LoginCard.css';

/**
 * Shared login-screen shell (PRD-1236, John's login template node 969-1490).
 * Every login state — Default Login, OTP entry, OTP error — renders inside this
 * one card: branding (logo) that never changes, the screen's own content in the
 * middle, and the fixed footer. Links in the footer are placeholders, matching
 * today's behaviour.
 */
function LoginCard({ children }) {
  return (
    <div className="login-container">
      <div className="login-inner">
        <div className="login-card resui-card">
          <div className="login-branding">
            <img
              src={`${process.env.PUBLIC_URL || ''}/resai-logo-stacked.png`}
              srcSet={
                `${process.env.PUBLIC_URL || ''}/resai-logo-stacked.png 1x, `
                + `${process.env.PUBLIC_URL || ''}/resai-logo-stacked@2x.png 2x, `
                + `${process.env.PUBLIC_URL || ''}/resai-logo-stacked@3x.png 3x`
              }
              alt="ResAI"
              className="login-logo-img"
              width={100}
              height={97}
            />
          </div>

          <div className="login-body">{children}</div>

          <div className="login-footer">
            <a href="/support" className="login-support-link">
              Having trouble signing in? Contact support
            </a>
            <div className="login-footer-legal">
              <a href="/conditions" className="login-footer-link">Conditions of Use</a>
              <a href="/privacy" className="login-footer-link">Privacy Notice</a>
              <a href="/help" className="login-footer-link">Help</a>
            </div>
            <div className="login-copyright">© {new Date().getFullYear()} ResolveHD Inc.</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginCard;
